export default "__VITE_ASSET__212468ec__"